import React from "react";
import Textbooks from "./Textbooks";

export default function ProfileLeft() {
  return <Textbooks />;
}
